import script from "./OnboardingTutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingTutorial.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingTutorial.vue?vue&type=style&index=0&id=63590d9a&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63590d9a"]])

export default __exports__